import type { CRMTaskComment } from "@/types";
import type { CommentData } from "@/components/CommentList";

/**
 * Normalizes a CRMTask's comments into the shape CommentList expects:
 * sorts oldest-first by `createdAt`, falls back to `author.name` when the
 * server-supplied `authorName` is empty, and converts `photo: null` to
 * `undefined` so it matches CommentAuthor.photo.
 */
export default function mapTaskComments(comments: CRMTaskComment[] | null | undefined): CommentData[] {
  return [...(comments ?? [])]
    .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
    .map((c) => ({
      id: c.id,
      content: c.content,
      author: {
        id: c.author.id,
        name: c.authorName || c.author.name || "",
        photo: c.author.photo ?? undefined
      },
      createdAt: c.createdAt,
      updatedAt: c.updatedAt
    }));
}
